function PrivacyPolicy() {
  return (
    <div>
      <iframe
        src="https://hljcreative.com/privacy-policy"
        style={{
          width: "100%",
          height: "calc(100vh - 50px)",
        }}
      />
    </div>
  );
}

export default PrivacyPolicy;
